import { useRef } from "react";
import { UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAccount } from "../model/context";

export function AccountMenu() {
  const account = useAccount();
  const { t } = useTranslation();
  const details = useRef<HTMLDetailsElement>(null);
  if (!account?.state.session) return null;
  return <details ref={details} className="relative" onKeyDown={(event) => {
    if (event.key === "Escape" && details.current) { details.current.open = false; details.current.querySelector("summary")?.focus(); }
  }}>
    <summary className="flex cursor-pointer list-none items-center gap-1.5 rounded-full p-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" aria-label={t("account.menu")}>
      <UserRound className="size-4" aria-hidden="true" /><span className="hidden max-w-28 truncate md:inline">{account.state.session.user.username}</span>
    </summary>
    <div className="absolute right-0 top-9 z-50 grid min-w-48 gap-1 rounded-xl border border-border bg-card p-2 text-foreground shadow-xl">
      <span className="truncate px-3 py-2 text-xs text-muted-foreground">{account.state.session.user.username}</span>
      <button className="rounded-lg px-3 py-2 text-left hover:bg-muted focus-visible:ring-2 focus-visible:ring-accent" onClick={() => { if (details.current) details.current.open = false; account.controller.showPassword(); }}>{t("account.changePassword")}</button>
      <button className="rounded-lg px-3 py-2 text-left hover:bg-muted focus-visible:ring-2 focus-visible:ring-accent" onClick={() => void account.controller.logout()}>{t("account.signOut")}</button>
    </div>
  </details>;
}
